<template>
	<div class="app-container infoTab">
		<div class="mainTit">赛事信息</div>
		<div class="square">
			<div class="subTit">主办方</div>
			<div class="words">{{info.conductHost}}</div>
			<div class="subTit">承办方</div>
			<div class="words">{{info.contractor}}</div>
			<div v-for="(item,index) in info.partiesOther" :key="index">
				<div class="subTit">{{item.name}}</div>
				<div class="words">{{item.value}}</div>
			</div>
			<div class="subTit">赛事类型</div>
			<div class="words">{{info.typeName}}</div>
			<div class="subTit">赛事项目</div>
			<div class="words">{{info.itemName}}</div>
			<div class="subTit">举办点</div>
			<div class="words">{{info.provinceName}}</div>
			<div class="subTit">报名时间</div>
			<div class="words">{{ parseTime(info.applyStartTime, '{y}-{m}-{d} {h}:{i}') }} -
				{{ parseTime(info.applyEndTime, '{y}-{m}-{d} {h}:{i}') }}</div>
			<div class="subTit">举办时间</div>
			<div class="words">{{ parseTime(info.gameStartTime, '{y}-{m}-{d} {h}:{i}') }} -
				{{ parseTime(info.gameEndTime, '{y}-{m}-{d} {h}:{i}') }}</div>
			<div class="subTit">赛事形式</div>
			<div class="words">{{ info.gameGenre == '1' ? '个人赛' : '团体赛' }}</div>
			<div class="subTit">人数限制</div>
			<div class="words">{{ info.limitNum }}人</div>
		</div>
		<div class="square">
			<div class="subTit">赛事总结</div>
			<div class="words">{{ info.gameCompetitionSystem }}</div>
		</div>
		<div class="mainTit" v-if="info.ruleState== 1">赛事秩序册</div>
		<!-- orderFile -->
		<div class="fileItem" v-if="info.ruleState == 1">
			<div class="flx1 alnCt">
				<img :src="require(`../../../../assets/file/file_type_pdf.png`)" alt="" class="icon"
					v-if="info.orderFile&&info.orderFile.includes('pdf')">
				<img :src="require(`../../../../assets/file/file_type_word.png`)" alt="" class="icon" v-else>
				<div class="name flx1 elpss">{{info.orderFile&&info.orderFile.split(',')[0] || '赛事秩序册'}}</div>
			</div>
			<el-button size="small" plain type="primary" @click="filePreview(info.orderFile)">预览</el-button>
		</div>

		<div class="mainTit" v-if="info.gameRegulationFile">赛事成绩单</div>
		<!-- gameRegulationFile -->
		<div class="fileItem" v-if="info.gameRegulationFile">
			<div class="flx1 alnCt">
				<img :src="require(`../../../../assets/file/file_type_pdf.png`)" alt="" class="icon"
					v-if="info.gameRegulationFile&&info.gameRegulationFile.includes('pdf')">
				<img :src="require(`../../../../assets/file/file_type_word.png`)" alt="" class="icon" v-else>
				<div class="name flx1 elpss">{{info.gameRegulationFile&&info.gameRegulationFile.split(',')[0]}}</div>
			</div>
			<el-button size="small" plain type="primary" @click="filePreview(info.gameRegulationFile)">预览</el-button>
		</div>
		<div class="mainTit" v-if="info.gameInformFile">赛事通知</div>
		<!-- gameInformFile -->
		<div class="fileItem" v-if="info.gameInformFile">
			<div class="flx1 alnCt">
				<img :src="require(`../../../../assets/file/file_type_pdf.png`)" alt="" class="icon"
					v-if="info.gameInformFile&&info.gameInformFile.includes('pdf')">
				<img :src="require(`../../../../assets/file/file_type_word.png`)" alt="" class="icon" v-else>
				<div class="name flx1 elpss">{{info.gameInformFile&&info.gameInformFile.split(',')[0] || '赛事通知'}}</div>
			</div>
			<el-button size="small" plain type="primary" @click="filePreview(info.gameInformFile)">预览</el-button>
		</div>
		<div class="mainTit" v-if="info.gameRuleFile">比赛规则</div>
		<!-- gameRuleFile -->
		<div class="fileItem" v-if="info.gameRuleFile">
			<div class="flx1 alnCt">
				<img :src="require(`../../../../assets/file/file_type_pdf.png`)" alt="" class="icon"
					v-if="info.gameRuleFile&&info.gameRuleFile.includes('pdf')">
				<img :src="require(`../../../../assets/file/file_type_word.png`)" alt="" class="icon" v-else>
				<div class="name flx1 elpss">{{info.gameRuleFile&&info.gameRuleFile.split(',')[0] || '比赛规则'}}</div>
			</div>
			<el-button size="small" plain type="primary" @click="filePreview(info.gameRuleFile)">预览</el-button>
		</div>
		<!-- <div class="mainTit" v-if="info.ruleState == 1">赛事组织人员</div> -->
		<!-- organizationFile -->
		<!-- <div class="fileItem" v-if="info.ruleState == 1">
			<div class="flx1 alnCt">
				<img :src="require(`../../../../assets/file/file_type_pdf.png`)" alt="" class="icon"
					v-if="info.organizationFile&&info.organizationFile.includes('pdf')">
				<img :src="require(`../../../../assets/file/file_type_word.png`)" alt="" class="icon" v-else>
				<div class="name flx1 elpss">{{info.organizationFile&&info.organizationFile.split(',')[0] || '赛事组织人员'}}
				</div>
			</div>
			<el-button size="small" plain type="primary" @click="filePreview(info.organizationFile)">预览</el-button>
		</div> -->
		
		<div class="mainTit" v-if="info.prizeState == 1">赛事颁奖</div>
		<!-- prizeFile -->
		<div class="fileItem" v-if="info.prizeState == 1">
			<div class="flx1 alnCt">
				<img :src="require(`../../../../assets/file/file_type_pdf.png`)" alt="" class="icon"
					v-if="info.prizeFile&&info.prizeFile.includes('pdf')">
				<img :src="require(`../../../../assets/file/file_type_word.png`)" alt="" class="icon" v-else>
				<div class="name flx1 elpss">{{info.prizeFile&&info.prizeFile.split(',')[0] || '赛事颁奖'}}</div>
			</div>
			<el-button size="small" plain type="primary" @click="filePreview(info.prizeFile)">预览</el-button>
		</div>

	</div>
</template>

<script>
	import * as API_Game from "@/api/sportManage/game";

	export default {
		name: "infoTab",
		props: ["id", "name"],
		data() {
			return {
				info: {}
			};
		},
		watch: {
			name: {
				handler(newVal, oldVal) {
					if (newVal == 'detail') this._getInfo()
				},
			}
		},
		created() {},
		methods: {
			// 接口-赛事信息
			_getInfo() {
				API_Game.gameInfo({
					id: this.id
				}).then((res) => {
					console.log(res.data.partiesOther);
					this.info = JSON.parse(JSON.stringify(res.data))
					this.info.partiesOther = JSON.parse(this.info.partiesOther)

				})
			},
			downloadFile(item) {
				// console.log(item);
				let a = document.createElement('a')
				a.href = item.filePath;
				a.download = item.fileName;
				a.click();
			},
			filePreview(str) {
				console.log(str);
				if (str) {
					// let url = str.split(',')[1]
					window.open(str, 'newWindow');
				} else {
					  this.$message('该文件暂未上传');
				}

			}
		},
	};
</script>

<style lang="scss">
	.infoTab {
		color: #676a6c;
		font-size: 13px;
		font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		overflow-x: hidden;

		.mainTit {
			margin-bottom: 10px;
			font-size: 16px;
			font-weight: bold;
			color: #aaa;
		}

		.square {
			padding: 10px 20px;
			width: 500px;
			margin-bottom: 20px;
			border-radius: 10px;
			border: 1px solid rgba(255, 255, 255, .1);
		}

		.subTit {
			position: relative;
			padding-left: 10px;
			margin: 10px 0;
			font-weight: bold;
			color: #aaa;
			line-height: 18px;

			&::before {
				content: '';
				position: absolute;
				left: 0;
				top: 2px;
				height: 12px;
				width: 2px;
				background-color: #00cb9c;
			}
		}

		.fileItem {
			display: flex;
			width: 300px;
			padding: 10px 0;
			margin-bottom: 10px;
			border-bottom: 1px solid rgba(255, 255, 255, .1);

			.icon {
				width: 30px;
				height: 30px;
				margin-right: 4px
			}

			.name {
				margin-right: 10px;
			}
		}
	}

	.words {
		word-wrap: break-word;
		color: #fff;
	}
</style>


<style lang="scss">
	@import "../../../../assets/styles/common.scss";
</style>